"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _fieldNames = require("./fieldNames");
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Uf = function Uf(props) {
  var strings = props.strings,
    form = props.form,
    field = props.field,
    pacientePadrao = props.pacientePadrao,
    obrigatorio = props.obrigatorio,
    somenteLeitura = props.somenteLeitura,
    meta = props.meta,
    ufCep = props.ufCep,
    errors = props.errors,
    submitCount = props.submitCount;
  var name = field.name,
    value = field.value,
    onBlur = field.onBlur;
  var setFieldValue = form.setFieldValue,
    values = form.values;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    ufs = _useState2[0],
    setUfs = _useState2[1];
  (0, _react.useEffect)(function () {
    var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
    if (values[_fieldNames.PAIS] && values[_fieldNames.PAIS].id) {
      _axios["default"].get("".concat(UTILITARIOS_API_BASE_URL, "/localizacao/estado?id-pais=").concat(values[_fieldNames.PAIS].id)).then(function (response) {
        if (response.data) {
          var itens = response.data.data.itens;
          setUfs(itens);
          if (value) {
            if (Number.isInteger(value)) {
              var estado = itens.find(function (e) {
                return e.id === value;
              });
              setFieldValue(_fieldNames.UF, estado);
            }
          }
        }
      })["catch"](function (err) {
        return console.log(err);
      });
    } else {
      setUfs([]);
    }
  }, [values[_fieldNames.PAIS]]);
  (0, _react.useEffect)(function () {
    if (ufCep) {
      var uf = ufs.filter(function (item) {
        return item.sigla === ufCep;
      });
      setFieldValue(_fieldNames.UF, uf[0]);
    }
  }, [ufCep]);
  return /*#__PURE__*/_react["default"].createElement(_core.SttAutocomplete, {
    inputprops: {
      name: name,
      label: strings.uf,
      required: obrigatorio,
      error: errors && (meta.touched && errors[_fieldNames.UF] || errors[_fieldNames.UF] && submitCount > 0) ? errors[_fieldNames.UF] : undefined
    },
    getOptionLabel: function getOptionLabel(option) {
      return option && option.sigla || '';
    },
    getOptionSelected: function getOptionSelected(option, val) {
      return option && val && option.id === val.id;
    },
    options: ufs,
    value: value,
    onBlur: onBlur,
    disabled: somenteLeitura || pacientePadrao,
    onChange: function onChange(e, item) {
      setFieldValue(_fieldNames.UF, item || null);
      setFieldValue(_fieldNames.MUNICIPIO, null);
    }
  });
};
var _default = exports["default"] = Uf;